
import { Vue, Component } from 'vue-property-decorator';
import LoginForm from '@/components/views/login/LoginForm.vue';
import RoltekHeaderLogo from '@/icons/RoltekHeaderLogo.vue';
import { Col } from 'ant-design-vue';
import { Row } from 'ant-design-vue';
import GlideCarousel from '@/components/global/GlideCarousel.vue';
import BackgroundImageRepository from '@/repositories/BackgroundImageRepository';
import BackgroundImage from '@/models/BackgroundImage';

@Component({
    name: 'Login',
    components: {
        LoginForm,
        RoltekHeaderLogo,
        Col,
        Row,
        GlideCarousel,
    },
})
export default class Login extends Vue {
    private currentYear: number = new Date().getFullYear();

    private get glideOptions() {
        return {
            perView: 1,
            autoplay: 4000,
            hoverpause: false,
            startAt: Math.floor(Math.random() * this.glideImages.length),
        };
    }

    private get backgroundImages() {
        return BackgroundImageRepository.getAll();
    }

    private get glideImages() {
        const images: any = [];
        const backgroundImages = this.backgroundImages;

        if (backgroundImages && backgroundImages.length > 0) {
            // Use background images from API
            backgroundImages.forEach((image, index) => {
                const imageUrl = this.getImageUrl(image);
                if (imageUrl) {
                    images.push({
                        src: imageUrl,
                        alt: image.displayName || image.title || `Background Image ${index + 1}`,
                    });
                }
            });
        }

        return images;
    }

    private getImageUrl(image: BackgroundImage): string {
        if (image.image) {
            // If the image field contains a full URL, use it
            if (image.image.startsWith('http')) {
                return image.image;
            }
            // If it's a relative path, prepend the base URL
            if (image.image.startsWith('/uploads/')) {
                return image.image;
            }
            // If it's just a filename, construct the full path
            return `/uploads/images/${image.image}`;
        }
        return '';
    }

    private async loadImages() {
        try {
            await BackgroundImage.getAll();
        } catch (error) {
            console.error('Failed to load background images:', error);
        }
    }

    private async mounted() {
        await this.loadImages();
    }
}
